import React, { useState } from 'react';
import Dialog from '@uiElements/Dialog';
import Button from '@uiElements/Button';
import Input from '@uiElements/Input';
import Select from '@uiElements/Select';
import SelectItem from '@uiElements/SelectItem';
import DatePicker from '@uiElements/Datepicker';
import Checkbox from '@uiElements/Checkbox';
const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const monthDays = Array.from({ length: 31 }, (_, i) => i + 1);
const typeRepeat = [{"key":"daily",value:"Day(s)"},{"key":"weekly",value:"Week(s)"},{"key":"monthly",value:"Month(s)"},{"key":"yearly",value:"Year(s)"}];
export default function CustomTaskRepeat({ defaultValue = {}, onSave }) {
  const [open, setOpen] = useState(false);
  const [repeatEvery, setRepeatEvery] = useState(defaultValue.repeat_every || 1);
  const [repeatOn, setRepeatOn] = useState(defaultValue.repeat_on || 'daily');
  const [selectedWeekdays, setSelectedWeekdays] = useState(defaultValue.days || []);
  const [selectedMonthDay, setSelectedMonthDay] = useState(defaultValue.monthly || 1);
  const [ends, setEnds] = useState(defaultValue.ends || 'never');
  const [endOnDate, setEndOnDate] = useState(defaultValue.end_on_date || null);
  const [afterOccurrences, setAfterOccurrences] = useState(defaultValue.occurrences || 1);

  const toggleWeekday = (day) => {
    setSelectedWeekdays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const handleSave = () => {
    const values = {
      repeat_every: repeatEvery,
      repeat_on: repeatOn,
      days: repeatOn === 'weekly' ? selectedWeekdays : null,
      monthly: repeatOn === 'monthly' ? selectedMonthDay : null,
      ends,
      end_on_date: ends === 'on' ? endOnDate : null,
      occurrences: ends === 'after' ? afterOccurrences : null,
    };
    onSave(values);
    setOpen(false);
  };

  return (
    <div>
      <Button onClick={() => setOpen(true)}>Custom Repeat</Button>
      <Dialog isOpen={open} onClose={()=>{setOpen(false)}} onOpenChange={setOpen} title="Custom Repeat Options">
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <span>Repeat every</span>
            <Input
              type="number"
              min={1}
              value={repeatEvery}
              onChange={(e) => setRepeatEvery(Number(e.target.value))}
              className="w-20"
            />
            <Select value={repeatOn} options={typeRepeat} onChange={(e)=>{setRepeatOn(e.target.value)}}>
            </Select>
            {repeatOn}
          </div>

          {repeatOn === 'weekly' && (
            <div className="flex flex-wrap gap-2">
              {weekdays.map((day) => (
                <Checkbox
                  key={day}
                  checked={selectedWeekdays.includes(day)}
                  onCheckedChange={() => toggleWeekday(day)}
                  label={day}
                />
              ))}
            </div>
          )}

          {repeatOn === 'monthly' && (
            <div className="flex items-center gap-2">
              <span>Select day:</span>
              <Select
                value={String(selectedMonthDay)}
                onValueChange={(val) => setSelectedMonthDay(Number(val))}
              >
                {monthDays.map((day) => (
                  <SelectItem key={day} value={String(day)}>
                    {day}
                  </SelectItem>
                ))}
              </Select>
            </div>
          )}

          <div className="space-y-2">
            <label className="font-medium text-sm text-gray-700">Ends</label>
            <div className="flex flex-col gap-2">
              <label className="flex gap-2 items-center">
                <input
                  type="radio"
                  name="ends"
                  value="never"
                  checked={ends === 'never'}
                  onChange={() => setEnds('never')}
                />
                Never
              </label>
              <label className="flex gap-2 items-center">
                <input
                  type="radio"
                  name="ends"
                  value="on"
                  checked={ends === 'on'}
                  onChange={() => setEnds('on')}
                />
                On
                {ends === 'on' && (
                  <DatePicker
                    selected={endOnDate}
                    onChange={(date) => setEndOnDate(date)}
                    className="ml-2"
                  />
                )}
              </label>
              <label className="flex gap-2 items-center">
                <input
                  type="radio"
                  name="ends"
                  value="after"
                  checked={ends === 'after'}
                  onChange={() => setEnds('after')}
                />
                After
                {ends === 'after' && (
                  <Input
                    type="number"
                    min={1}
                    value={afterOccurrences}
                    onChange={(e) => setAfterOccurrences(Number(e.target.value))}
                    className="ml-2 w-24"
                  />
                )} occurrences
              </label>
            </div>
          </div>

          <div className="text-right pt-4">
            <Button onClick={handleSave}>Save</Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
